export default "__VITE_ASSET__BF29t2J2__"